import script from "./MainStore.vue?vue&type=script&setup=true&lang=js"
export * from "./MainStore.vue?vue&type=script&setup=true&lang=js"

import "./MainStore.vue?vue&type=style&index=0&id=905f75de&scoped=true&lang=stylus"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-905f75de"]])

export default __exports__